import { Star } from "lucide-react";

const reviews = [
  { name: "Daan V.", role: "Schema — Spieropbouw", avatar: "DV", rating: 5, text: "Het schema is ongelooflijk overzichtelijk opgebouwd. Elke week weet ik precies wat ik moet doen. In 3 maanden meer resultaat geboekt dan in het vorige jaar." },
  { name: "Lisa M.", role: "Personal Training — Cursus", avatar: "LM", rating: 5, text: "De combinatie van het schema én de cursus is goud. Ik begrijp nu waarom ik doe wat ik doe, en dat maakt het zoveel makkelijker om gemotiveerd te blijven." },
  { name: "Roel B.", role: "Cursus — PT Kickstart", avatar: "RB", rating: 5, text: "De cursus legt alles glashelder uit. Van progressieve overload tot voeding — alles is onderbouwd. Certificaat ontvangen na de eindtoets. Super professioneel." },
  { name: "Nadia K.", role: "Schema — Vetverlies", avatar: "NK", rating: 5, text: "Ik was sceptisch over online programma's, maar dit heeft mijn mening veranderd. Het schema is duidelijk en ik ben al 6 weken consistent aan het trainen. Resultaat is zichtbaar!" },
];

export default function ReviewsSection() {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 lg:py-28 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="overline mb-3">Ervaringen</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Wat onze cursisten zeggen</h2>
          <div className="flex items-center justify-center gap-2">
            <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} size={18} className="text-[#C9A84C] fill-[#C9A84C]" />)}</div>
            <span className="text-white font-bold">4,8/5</span>
            <span className="text-zinc-500 text-sm">— 25+ beoordelingen</span>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {reviews.map(r => (
            <div key={r.name} data-testid={`review-card-${r.name}`} className="review-card group">
              <div className="flex items-start gap-3 mb-4">
                <div className="review-avatar">{r.avatar}</div>
                <div>
                  <p className="text-white font-semibold text-sm">{r.name}</p>
                  <p className="text-zinc-500 text-xs">{r.role}</p>
                </div>
              </div>
              <div className="flex mb-3">{[...Array(r.rating)].map((_, i) => <Star key={i} size={14} className="text-[#C9A84C] fill-[#C9A84C]" />)}</div>
              <p className="text-zinc-400 text-sm leading-relaxed">"{r.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
